import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import luganeseIcon from '../static/images/region_icons/luganese-icon.png';
import mendrisiottoIcon from '../static/images/region_icons/mendrisiotto-icon.png';
import bellinzoneseIcon from '../static/images/region_icons/bellinzonese-icon.png';
import locarneseIcon from '../static/images/region_icons/locarnese-icon.png';
import { setNewFilters } from '../redux/filtersSlice';
import { setIsPoolOpen } from '../redux/searchbarSlice';


const RegionIconSection = () => {
    const [regions] = useState([
        'Luganese', 'Mendrisiotto', 'Bellinzona e Valli', 'Ascona-Locarno'
    ]);

    // Imposta filtro region prima di passare alla pagina di ricerca
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleRegionClick = (region) => {
        dispatch(setNewFilters({ region: region }));
        navigate('/all-activities');
    }
    return (
        <div className="flex w-full lg:w-[1000px] overflow-x-auto scrollbar-hide">
            <div onClick={() => handleRegionClick(regions[3])} className=''>
                <img src={locarneseIcon} className='min-w-36' />
            </div>
            <div onClick={() => handleRegionClick(regions[2])} className=''>
                <img src={bellinzoneseIcon} className='min-w-36' />
            </div>
            <div onClick={() => handleRegionClick(regions[0])} className=''>
                <img src={luganeseIcon} className='min-w-36' />
            </div>
            <div onClick={() => handleRegionClick(regions[1])} className=''>
                <img src={mendrisiottoIcon} className='min-w-36' />
            </div>
        </div>
    )
}

export default RegionIconSection;